import { Stack, Typography } from '@mui/material';
import React from 'react';

import { AccordionWithHeading } from '../../components/general/index.js';
import { type ModulFromThemaRouter } from '../../dtos.js';
import { SidebarModulCard } from './SidebarModulCard.js';

type ModuleSectionProps = {
  readonly module: ModulFromThemaRouter[];
};

// Es sind deutsche "Module" (plural), kein englisches "Module" (singular)
export const ModuleSection: React.FC<ModuleSectionProps> = ({ module }) => {
  if (module.length === 0) {
    return (
      <AccordionWithHeading heading="Module" bordered={false}>
        <Typography>Keine Module vorhanden</Typography>
      </AccordionWithHeading>
    );
  }

  return (
    <AccordionWithHeading heading="Module" bordered={false}>
      <Stack spacing={2}>
        {module.map((modul) => (
          <SidebarModulCard key={modul.modulnummer} modul={modul} />
        ))}
      </Stack>
    </AccordionWithHeading>
  );
};
